import { fromJS, Map } from 'immutable';
import { handleActions } from 'redux-actions';

import {
  keepDraftState,
  restoreDraftState,
} from 'shared/actions/draft';


// Under top level key 'draft'.
const initialState = fromJS({});


export default handleActions({
  [restoreDraftState]: (state, action) => {
    const { payload } = action;
    const { rawStateObj } = payload;
    if (!rawStateObj) return state;

    // NOTE(thx): Don't use fromJS here because it
    // will deeply convert plain JS objects into
    // immutable ones and we shouldn't make assumptions
    // as to how each module handle its state.
    return Map(rawStateObj);
  },

  [keepDraftState]: (state, action) => {
    const { payload } = action;
    const { moduleId, draftState } = payload;

    return state.set(moduleId, draftState);
  },

}, initialState);



// WEBPACK FOOTER //
// ./src/shared/reducers/draft.js